// outline blue button

import React from "react";
import { arrowRightSvg } from "./Assets";
export default function ArrowBtn({ children, onClick, size = 16 }) {
  // button with arrow image
  return (
    <button className="flex items-center" onClick={onClick}>
      {children}
      <img
        src={arrowRightSvg}
        alt="arrow"
        className="ml-2.5"
        // style={{ width: `${size}px`, height: `${size}px` }}
      />
    </button>
  );
}
